<template>
  <div>
    <el-dialog
  title="修改指标"
  :visible.sync="dialogVisible"
  :before-close="handleClose"
  width="30%">
 <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
  <el-form-item label="所属领域" prop="domain_id" :required="true">
     <el-select v-model="ruleForm.domain_id" placeholder="选择所属领域">
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
  </el-form-item>
  <el-form-item label="指标" prop="index_description">
    <el-input  v-model="ruleForm.index_description" autocomplete="off"></el-input>
  </el-form-item>
  <el-form-item label="精简指标" prop="index">
    <el-input v-model.number="ruleForm.index"></el-input>
  </el-form-item>
  <el-form-item label="单位" prop="unit">
    <el-input v-model.number="ruleForm.unit"></el-input>
  </el-form-item>
  <el-form-item label="指标类别" prop="classification">
    <el-input v-model.number="ruleForm.classification"></el-input>
  </el-form-item>
  <el-form-item label="重要性" prop="importance" :required="true">
    <el-select v-model="ruleForm.importance" placeholder="请选择重要性">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="数据来源" prop="source_foreign"  show-overflow-tooltip>
    <el-input v-model.number="ruleForm.source_foreign"></el-input>
  </el-form-item>
  <el-form-item label="可获得性" prop="permission_foreign">
    <el-input v-model.number="ruleForm.permission_foreign"></el-input>
  </el-form-item>
  <el-form-item label="数据范围" prop="range_foreign">
    <el-input v-model.number="ruleForm.range_foreign"></el-input>
  </el-form-item>
  <el-form-item label="更新频率" prop="frequency_foreign">
    <el-input v-model.number="ruleForm.frequency_foreign"></el-input>
  </el-form-item>
  <el-form-item label="来源链接" prop="link_foreign">
    <el-input v-model.number="ruleForm.link_foreign"></el-input>
  </el-form-item>
  <el-form-item label="数据来源" prop="source">
    <el-input v-model.number="ruleForm.source"></el-input>
  </el-form-item>
  <el-form-item label="可获得性" prop="permission">
    <el-input v-model.number="ruleForm.permission"></el-input>
  </el-form-item>
  <el-form-item label="更新频率" prop="frequency">
    <el-input v-model.number="ruleForm.frequency"></el-input>
  </el-form-item>
   <el-form-item label="来源链接" prop="link">
    <el-input v-model.number="ruleForm.link"></el-input>
  </el-form-item>
   <el-form-item label="备注" prop="comment">
    <el-input v-model.number="ruleForm.comment"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="SubmitForm('ruleForm')">提交</el-button>
    <el-button @click="ResetForm('ruleForm')">清空</el-button>
  </el-form-item>
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="CloseUpdate">取 消</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import api from "@/services/python";
export default {
     props:{
        dialogVisible: {
          type: Boolean,
          required: true,
        },
        ruleForm: {
          type: Object,
          required: true,
        }, 
    },
    data() {
       var validateDomain_id = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('所属领域不能为空'));
        }else {
          callback();
        }
      };
      var checkImportance = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('重要性不能为空'));
        } else {
          callback();
        }
      };
      return {
        options: [{
          value: '重要指标',
          label: '重要指标'
        }, {
          value: '核心指标',
          label: '核心指标'
        }, {
          value: '一般指标',
          label: '一般指标'
        }],
        options2: [
        {
          value: 21,
          label: "微电子光电子",
        },
        {
          value: 22,
          label: "光学工程",
        },
        {
          value: 23,
          label: "感知",
        },
        {
          value: 24,
          label: "测量计量",
        },
        {
          value: 25,
          label: "电磁空间",
        },
        {
          value: 26,
          label: "网络与通信",
        },
        {
          value: 27,
          label: "信息安全",
        },
        {
          value: 28,
          label: "水声工程",
        },
         {
          value: 29,
          label: "电子场与电磁环境效应",
        },
         {
          value: 30,
          label: "控制",
        },
         {
          value: 31,
          label: "认知",
        },
         {
          value: 32,
          label: "计算机系统及软件",
        },{
          value: 33,
          label: "计算机应用",
        },
        ],
        rules: {
          domain_id: [
            { validator: validateDomain_id, trigger: 'blur' }
          ],
          importance: [
            { validator: checkImportance, trigger: 'blur' }
          ],
        }
      };
    },
    methods: {
      handleClose(){
          this.$emit("CloseUpdate")
      },
        CloseUpdate(){
            this.$emit("CloseUpdate")
        },
        SubmitForm(formName) {
        this.$refs[formName].validate(async(valid) => {
          if (valid) {
            const params = this.ruleForm.id
           const res = await api.key_index.partial_update(params,this.ruleForm).response.then(res => res.data)
           if(res.code == 200){
            this.$message({
              message: '修改成功',
              type: 'success',
            });
          }else{
            this.$message.error('修改失败');
          }
            this.$emit("CloseUpdate");//关闭窗口
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      ResetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  };
</script>

<style scoped>
/deep/.el-dialog__body::-webkit-scrollbar{
  width: 6px; 
height: 6px; 
   background-color: #ccc;
}

/deep/.el-dialog__body::-webkit-scrollbar-track {
        background-color: #ccc;
  }
  /deep/ .el-dialog__body {
        height: 400px;
        overflow: auto;
    }
</style>